export interface FilterValueType {
    textKey: string;
    operator: string;
    isString: boolean;
}

export const FilterValueTypes: FilterValueType[] = [
    {
        textKey: "HOME_COMPONENTS.MASTER_FILTER.OPERATORS.EQUAL_TO",
        operator: "eq",
        isString: false
    },
    {
        textKey: "HOME_COMPONENTS.MASTER_FILTER.OPERATORS.NOT_EQUAL_TO",
        operator: "neq",
        isString: false
    },
    {
        textKey: "HOME_COMPONENTS.MASTER_FILTER.OPERATORS.LESS_THAN",
        operator: "lt",
        isString: false
    },
    {
        textKey: "HOME_COMPONENTS.MASTER_FILTER.OPERATORS.LESS_THAN_OR_EQUAL_TO",
        operator: "lte",
        isString: false
    },
    {
        textKey: "HOME_COMPONENTS.MASTER_FILTER.OPERATORS.GREATER_THAN",
        operator: "gt",
        isString: false
    },
    {
        textKey: "HOME_COMPONENTS.MASTER_FILTER.OPERATORS.GREATER_THAN_OR_EQUAL_TO",
        operator: "gte",
        isString: false
    },
    {
        textKey: "HOME_COMPONENTS.MASTER_FILTER.OPERATORS.STARTS_WITH",
        operator: "startswith",
        isString: true
    },
    {
        textKey: "HOME_COMPONENTS.MASTER_FILTER.OPERATORS.ENDS_WITH",
        operator: "endswith",
        isString: true
    },
    {
        textKey: "HOME_COMPONENTS.MASTER_FILTER.OPERATORS.CONTAINS",
        operator: "contains",
        isString: true
    },
    {
        textKey: "HOME_COMPONENTS.MASTER_FILTER.OPERATORS.DOES_NOT_CONTAIN",
        operator: "doesnotcontain",
        isString: true
    },
    {
        textKey: "HOME_COMPONENTS.MASTER_FILTER.OPERATORS.IS_EMPTY",
        operator: "isempty",
        isString: true
    },
    {
        textKey: "HOME_COMPONENTS.MASTER_FILTER.OPERATORS.IS_NOT_EMPTY",
        operator: "isnotempty",
        isString: true
    },
];
